import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React from "react";
import PrimaryButtonComponentView from "src/app/components/primaryButton/primaryButton.view";
import SnackBarComponentView from "src/app/components/snackbar/snackbar.view";
import LoginScreenViewModel from "src/app/screens/login/login.screen.viewmodel";
import styles from "src/app/styles/screens/login.screen.style";

const LoginScreen: React.FC = () => {
  const {
    isPasswordVisible,
    togglePasswordVisibility,
    onEmailFieldChangedEvent,
    onPasswordFieldChangedEvent,
    isLoginLoading,
    onLoginPressed,
    loginErrorMessage,
    isDisplayingError,
    setIsDisplayingError,
    isCheckingToken,
  } = LoginScreenViewModel();
  return (
    <Box sx={styles.parent}>
      <Container maxWidth="sm" sx={styles.container}>
        <Paper sx={styles.mainPaper} elevation={5}>
          <Box sx={styles.shapesContainer}>
            <Box sx={styles.topLeftShape} />
            <Box sx={styles.bottomRightShape} />
          </Box>
          <Box sx={styles.elementsContainer}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ width: "100%" }}
            >
              <Grid size={{ xs: 11, sm: 10, md: 8 }}>
                <TextField
                  fullWidth
                  type="email"
                  placeholder="Email address"
                  variant="outlined"
                  sx={styles.emailTextField}
                  onChange={onEmailFieldChangedEvent}
                />
              </Grid>
              <Grid size={{ xs: 11, sm: 10, md: 8 }}>
                <Box sx={styles.passwordContainer}>
                  <TextField
                    fullWidth
                    type={isPasswordVisible ? "text" : "password"}
                    placeholder="Password"
                    variant="outlined"
                    sx={styles.passwordTextField}
                    onChange={onPasswordFieldChangedEvent}
                  />
                  <Button onClick={togglePasswordVisibility}>
                    {isPasswordVisible ? (
                      <VisibilityIcon sx={styles.visibilityIcon} />
                    ) : (
                      <VisibilityOffIcon sx={styles.visibilityIcon} />
                    )}
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <PrimaryButtonComponentView
              text="Login"
              loading={isLoginLoading}
              onClick={onLoginPressed}
            />
          </Box>
        </Paper>
      </Container>
      <SnackBarComponentView
        message={loginErrorMessage}
        isError
        isOpen={isDisplayingError}
        onClose={() => setIsDisplayingError(false)}
      />
      {isCheckingToken && (
        <Box sx={styles.overlay}>
          <CircularProgress size={60} />
        </Box>
      )}
    </Box>
  );
};

export default LoginScreen;
